import { CannedResponseCompact } from "../../../models/new/automation/canned-response-compact.model";
import { CannedResponseFull } from "../../../models/new/automation/canned-response-full.model";
import { Action } from "../../action";

export enum CannedResponseActionTypes {
  INDEX_REQUEST = "[Canned Response NEW] Index Request",
  INDEX_SUCCESS = "[Canned Response NEW] Index Success",

  CREATE_REQUEST = "[Canned Response NEW] Create Request",
  CREATE_SUCCESS = "[Canned Response NEW] Create Success",

  SHOW_REQUEST = "[Canned Response NEW] Show Request",
  SHOW_SUCCESS = "[Canned Response NEW] Show Success",

  UPDATE_REQUEST = "[Canned Response NEW] Update Request",
  UPDATE_SUCCESS = "[Canned Response NEW] Update Success",

  DELETE_REQUEST = "[Canned Response NEW] Delete Request",
  DELETE_SUCCESS = "[Canned Response NEW] Delete Success",
}

export class CannedResponseIndexRequest implements Action {
  readonly type = CannedResponseActionTypes.INDEX_REQUEST;
}

export class CannedResponseIndexSuccess implements Action {
  readonly type = CannedResponseActionTypes.INDEX_SUCCESS;

  constructor(public payload: CannedResponseCompact[]) {
  }
}

export class CannedResponseCreateRequest implements Action {
  readonly type = CannedResponseActionTypes.CREATE_REQUEST;
}

export class CannedResponseCreateSuccess implements Action {
  readonly type = CannedResponseActionTypes.CREATE_SUCCESS;

  constructor(public payload: CannedResponseFull) {
  }
}

export class CannedResponseShowRequest implements Action {
  readonly type = CannedResponseActionTypes.SHOW_REQUEST;

  constructor(public payload: number) {

  }
}

export class CannedResponseShowSuccess implements Action {
  readonly type = CannedResponseActionTypes.SHOW_SUCCESS;

  constructor(public payload: CannedResponseFull) {
  }
}

export class CannedResponseUpdateRequest implements Action {
  readonly type = CannedResponseActionTypes.UPDATE_REQUEST;

  constructor(public payload: number) {
  }
}

export class CannedResponseUpdateSuccess implements Action {
  readonly type = CannedResponseActionTypes.UPDATE_SUCCESS;

  constructor(public payload: CannedResponseFull) {
  }
}

export class CannedResponseDeleteRequest implements Action {
  readonly type = CannedResponseActionTypes.DELETE_REQUEST;

  constructor(public payload: number) {
  }
}

export class CannedResponseDeleteSuccess implements Action {
  readonly type = CannedResponseActionTypes.DELETE_SUCCESS;

  constructor(public payload: number) {
  }
}
